import React from 'react';
import { IconProps } from '.';

const SvgArrowChevronLeft = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='m15.47 3.47 1.06 1.06L9.06 12l7.47 7.47-1.06 1.06L6.94 12l8.53-8.53Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgArrowChevronLeft;
